module.exports = __webpack_public_path__ + "static/40ae8eba0c96f4ced8394007e837322e159d7ca42fabf774c70e6fcbe3815eab-f0f723b632d4cd6a1b41b73e9fc3d5af.jpeg";